module.exports = __webpack_public_path__ + "img/scroll-icon-3.79bfa7cc.png";